<div class="mt-result-container">
  @if (isLoading) {
    <div class="loading-indicator">Lade Daten...</div>
  }

  @if (error) {
    <div class="error-message">
      {{ error }}
    </div>
  }

  @if (mtResult$ | async; as resultData) {
    @if (resultData && resultData.current && resultData.original) {
      <div>
        <app-simple-json-diff [current]="resultData.current" [original]="resultData.original"> </app-simple-json-diff>
      </div>
    }
    @if (resultData && (!resultData.current || !resultData.original)) {
      <div>
        <p>Original- oder aktuelle Daten fehlen für den Vergleich.</p>
        @if (resultData.current) {
          <details>
            <summary>Aktuelle Daten</summary>
            <pre>{{ resultData.current | json }}</pre>
          </details>
        }
        @if (resultData.original) {
          <details>
            <summary>Original Daten</summary>
            <pre>{{ resultData.original | json }}</pre>
          </details>
        }
      </div>
    }
  } @else {
    @if (!isLoading && !error) {
      <p>Keine Daten verfügbar.</p>
    }
  }
</div>
